import { createSlice } from "@reduxjs/toolkit";
import { deleteChargingDeviceConnectorsAPI } from "../../actions/chargingDevice/deleteChargingDeviceConnector";

const initialState = {
  addUser: {},
  loading: false,
  error: null,
};

const deleteChargingDeviceConnectorSlice = createSlice({
  name: "deleteChargingDeviceConnector",
  initialState,
  reducers: {
    deleteUserData: (state, action) => {
      state.addUser = action.payload.userAdded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteChargingDeviceConnectorsAPI.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteChargingDeviceConnectorsAPI.fulfilled, (state, action) => {
        state.addUser = action.payload.userDeleted;
        state.loading = false;
      })
      .addCase(deleteChargingDeviceConnectorsAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { deleteUserData } = deleteChargingDeviceConnectorSlice.actions;
export default deleteChargingDeviceConnectorSlice.reducer;
